import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import {
    Row,
    Col,
    Tag
} from 'antd'

const zones = [ "east", "central", "north", "south", "west" ]

class PerZoneCounter extends React.Component {

    constructor(props) {
        super(props);
    }

    

    render(){

        

        return(
            <Row span={4.5} style={{fontSize:'16px', width:'100%', textAlign:'center', padding:'10px', marginBottom:'15px'}}>
                <div>{moment(this.props.date).format('ddd DD/MM/YYYY')}</div>
                <Row type="flex" justify="space-around" style={{height:'40px', borderBottom:'0.25px solid black', alignItems:'center'}}>
                    <Col span={2} style={{marginBottom:'10px'}}><Tag color='red'>Zone</Tag></Col>
                    <Col span={2} style={{marginBottom:'10px'}}><Tag color='purple'>P</Tag></Col>
                    <Col span={2} style={{marginBottom:'10px'}}><Tag color='blue'>D</Tag></Col>
                </Row>
                {
                    zones.map( _zone =>
                        <Row 
                            type="flex" 
                            justify="space-around" 
                            style={{
                                height:'40px', 
                                borderBottom:'0.25px solid black', 
                                alignItems:'center', 
                                backgroundColor:`${this.props.zoneRules[moment(this.props.date).format('ddd')].includes(_zone.charAt(0).toUpperCase()+ _zone.slice(1)) ? 'yellow' : null}`
                            }}
                        >
                            <Col span={2} style={{fontSize:'12px'}}>{_zone.charAt(0).toUpperCase()+ _zone.slice(1)}</Col>
                            <Col span={2} style={{fontSize:'12px'}}>{this.props.countObj[`${_zone}Pickup`]}</Col>
                            <Col span={2} style={{fontSize:'12px'}}>{this.props.countObj[`${_zone}Delivery`]}</Col>
                        </Row>
                    )
                }
            </Row>
        )
    }


    shouldComponentUpdate(nextProps, nextState){
        let condition = nextProps.countObj.eastPickup === this.props.countObj.eastPickup &&
            nextProps.countObj.eastDelivery === this.props.countObj.eastPickup &&

            nextProps.countObj.centralPickup === this.props.countObj.centralPickup &&
            nextProps.countObj.centralDelivery === this.props.countObj.centralPickup &&

            nextProps.countObj.southPickup === this.props.countObj.southPickup &&
            nextProps.countObj.southDelivery === this.props.countObj.southPickup &&

            nextProps.countObj.northPickup === this.props.countObj.northPickup &&
            nextProps.countObj.northDelivery === this.props.countObj.northPickup &&

            nextProps.countObj.westPickup === this.props.countObj.westPickup &&
            nextProps.countObj.westDelivery === this.props.countObj.westPickup

        if( !condition ){
            return true
        }else{
            return false
        }
    }

    sectorCounter = (locationObject) => {
		let eastPickup = [],
        centralPickup = [],
        southPickup = [],
        northPickup = [],
        westPickup = [],

        eastDelivery = [],
        centralDelivery = [],
        southDelivery = [],
        northDelivery = [],
        westDelivery = []

        
        Object.keys(locationObject).map(date=>{
            let eastP = 0,
                centralP = 0,
                southP = 0,
                northP = 0,
                westP = 0,

                eastD = 0,
                centralD = 0,
                southD = 0,
                northD = 0,
                westD = 0

            locationObject[date].eezeeSend.map(_location=>{
                if(_location.address.zone === 'East'){
                    if(_location.locationActionRequired === 'pickup'){
                        eastP = eastP + 1
                    }
                    if(_location.locationActionRequired === 'delivery'){
                        eastD = eastD + 1
                    }
                }
                if(_location.address.zone === 'Central'){
                    if(_location.locationActionRequired === 'pickup'){
                        centralP = centralP + 1
                    }
                    if(_location.locationActionRequired === 'delivery'){
                        centralD = centralD + 1
                    }
                }
                if(_location.address.zone === 'South'){
                    if(_location.locationActionRequired === 'pickup'){
                        southP = southP + 1
                    }
                    if(_location.locationActionRequired === 'delivery'){
                        southD = southD + 1
                    }
                }
                if(_location.address.zone === 'North'){
                    if(_location.locationActionRequired === 'pickup'){
                        northP = northP + 1
                    }
                    if(_location.locationActionRequired === 'delivery'){
                        northD = northD + 1
                    }
                }
                if(_location.address.zone === 'West'){
                    if(_location.locationActionRequired === 'pickup'){
                        westP = westP + 1
                    }
                    if(_location.locationActionRequired === 'delivery'){
                        westD = westD + 1
                    }
                }
            })

            eastPickup.push(eastP)
            eastDelivery.push(eastD)
            centralPickup.push(centralP)
            centralDelivery.push(centralD)
            southPickup.push(southP)
            southDelivery.push(southD)
            northPickup.push(northP)
            northDelivery.push(northD)
            westPickup.push(westP)
            westDelivery.push(westD)
        })
       
        this.setState({
            count: {
                eastPickup: eastPickup,
                centralPickup: centralPickup,
                southPickup: southPickup,
                northPickup: northPickup,
                westPickup: westPickup,
                eastDelivery: eastDelivery,
                centralDelivery: centralDelivery,
                southDelivery: southDelivery,
                northDelivery: northDelivery,
                westDelivery: westDelivery
            }
        })
    }
}
export default PerZoneCounter;


// WEBPACK FOOTER //
// ./src/components/delivery-page/PerZoneCounter.js